import { Transport, TransportRequest, TransportResponse } from "../../../../core/internal/transport/Transport"
import { ApiCallMetrics } from "../../../../core/internal/metrics/monitoring/ApiCallMetrics"

export class InAppMessageHtmlContentFetcher {
  private HTML_REQUEST_TIMEOUT_MILLIS = 5000
  constructor(private readonly transport: Transport) {}

  async fetchHtmlContent(fetchSourcePath: string): Promise<string> {
    const request = this.createRequest(fetchSourcePath)
    const response = await this.execute(request)
    return this.handleResponse(response)
  }

  private createRequest(fetchSourcePath: string): TransportRequest {
    return TransportRequest.builder()
      .url(fetchSourcePath)
      .method("GET")
      .timeoutMillis(this.HTML_REQUEST_TIMEOUT_MILLIS)
      .build()
  }

  private execute(request: TransportRequest): Promise<TransportResponse> {
    return ApiCallMetrics.record("get.iam-html", () => this.transport.send(request))
  }

  private handleResponse(response: TransportResponse): string {
    if (!response.isSuccessful()) {
      throw new Error(`Http status code: ${response.statusCode}`)
    }

    if (response.body === null) {
      throw new Error("Response body is null")
    }

    return response.body
  }
}
